import { AxiosInstance } from 'axios';

import { Competition, CreateCompetition } from '../../types';
import { competitionEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

class CompetitionsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (competition: CreateCompetition): Promise<Competition> => {
    return this.#requestInstance.post(competitionEndpoints.competition, competition);
  };

  getCompetitions = async (): Promise<Competition[]> => {
    return this.#requestInstance.get(competitionEndpoints.competition);
  };

  deleteCompetition = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(competitionEndpoints.getCompetitionById(id));
  };

  getCompetition = async (id: number): Promise<Competition> => {
    return this.#requestInstance.get(competitionEndpoints.getCompetitionById(id));
  };

  updateCompetition = async (input: Competition): Promise<Competition> => {
    return this.#requestInstance.patch(competitionEndpoints.getCompetitionById(input?.id), input);
  };

  updateCompetitionStatus = async (input: Competition): Promise<Competition> => {
    return this.#requestInstance.patch(
      competitionEndpoints.updateCompetitionStepById(input?.id),
      input
    );
  };
}

export const competitionsApi = new CompetitionsApi(axios);
